import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Logout = ({ setIsAuthenticated }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const abortController = new AbortController();

    const logoutUser = async () => {
      try {
        console.log("Starting logout process...");
        await axios.post(
          `${process.env.REACT_APP_BASE_API_URL}/logout`,
          {},
          {
            withCredentials: true,
            signal: abortController.signal,
          }
        );

        localStorage.removeItem("token");
        localStorage.removeItem("userrole");
        localStorage.removeItem("driverName");
        if (setIsAuthenticated) {
          setIsAuthenticated(false);
        }

        if (
          navigator.credentials &&
          navigator.credentials.preventSilentAccess
        ) {
          navigator.credentials.preventSilentAccess();
        }

        setTimeout(() => {
          navigate("/", { replace: true });
        }, 100);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Error during logout:", error);
          setError(true);
          setLoading(false);
        }
      }
    };

    logoutUser();

    return () => {
      abortController.abort();
    };
  }, [navigate, setIsAuthenticated]);

  return (
    <div className="logout-container">
      {loading ? (
        <p>Logging out...</p>
      ) : error ? (
        <div>
          <p>Error during logout. Please try again.</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      ) : null}
    </div>
  );
};

export default Logout;
